(function () {
  'use strict';
  if (window.__heatlyLoaded) return;
  window.__heatlyLoaded = true;

  function fmtMoney(cents, format) {
    format = format || '₪{{amount}}';
    cents = Math.round(Number(cents) || 0);
    function delim(n, dec, th, sep) {
      var p = (n / 100).toFixed(dec).split('.');
      p[0] = p[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + th);
      return p[1] ? p[0] + sep + p[1] : p[0];
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return delim(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return delim(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return delim(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return delim(cents, 2, "'", '.');
        default: return cents % 100 === 0 ? delim(cents, 0, ',', '.') : delim(cents, 2, ',', '.');
      }
    });
  }

  function ilNow() {
    try { return new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Jerusalem' })); } catch (e) { return new Date(); }
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function untilHour(hour) {
    var now = ilNow(), t = new Date(now);
    t.setHours(hour, 0, 0, 0);
    if (t <= now) t.setDate(t.getDate() + 1);
    var d = Math.max(0, Math.floor((t - now) / 1000));
    return pad(Math.floor(d / 3600)) + ':' + pad(Math.floor((d % 3600) / 60)) + ':' + pad(d % 60);
  }
  function tickCountdowns() {
    document.querySelectorAll('[data-hx-until]').forEach(function (el) {
      el.textContent = untilHour(parseInt(el.getAttribute('data-hx-until'), 10) || 0);
    });
  }
  setInterval(tickCountdowns, 1000);

  var HE_DAYS = ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'];
  function addBusinessDays(n) {
    var d = ilNow(), added = 0;
    while (added < n) { d.setDate(d.getDate() + 1); var wd = d.getDay(); if (wd !== 5 && wd !== 6) added++; }
    return d;
  }
  function fmtDay(d) { return 'יום ' + HE_DAYS[d.getDay()] + ' ' + d.getDate() + '/' + (d.getMonth() + 1); }
  function initDelivery(root) {
    root.querySelectorAll('[data-hx-delivery]').forEach(function (el) {
      var a = el.querySelector('[data-from]'), b = el.querySelector('[data-to]');
      if (a) a.textContent = fmtDay(addBusinessDays(parseInt(el.getAttribute('data-min'), 10) || 5));
      if (b) b.textContent = fmtDay(addBusinessDays(parseInt(el.getAttribute('data-max'), 10) || 10));
    });
  }

  function initAnn(root) {
    root.querySelectorAll('[data-hx-ann]').forEach(function (bar) {
      if (bar.__hx) return; bar.__hx = 1;
      var msgs = bar.querySelectorAll('.hx-ann__msg');
      if (msgs.length < 2) return;
      var i = 0, speed = (parseInt(bar.getAttribute('data-speed'), 10) || 4) * 1000;
      setInterval(function () {
        msgs[i].classList.remove('is-active');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      }, speed);
    });
  }

  /* ---------- generic slider (RTL aware) ---------- */
  function initSliders(root) {
    root.querySelectorAll('[data-hx-slider]').forEach(function (sl) {
      if (sl.__hx) return; sl.__hx = 1;
      var track = sl.querySelector('.hx-slider__track');
      if (!track) return;
      var slides = Array.prototype.slice.call(track.children);
      if (slides.length < 2) return;
      var rtl = getComputedStyle(track).direction === 'rtl';
      var dotsWrap = sl.querySelector('.hx-dots');
      function step() {
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        return slides[0].getBoundingClientRect().width + gap;
      }
      function perView() { return Math.max(1, Math.round(track.clientWidth / step())); }
      function pages() { return Math.max(1, slides.length - perView() + 1); }
      function current() { return Math.round(Math.abs(track.scrollLeft) / step()); }
      function go(i) {
        var n = pages();
        i = ((i % n) + n) % n;
        var x = i * step();
        track.scrollTo({ left: rtl ? -x : x, behavior: 'smooth' });
      }
      function buildDots() {
        if (!dotsWrap) return;
        dotsWrap.innerHTML = '';
        for (var k = 0; k < pages(); k++) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'hx-dot'; b.setAttribute('aria-label', 'עברו לשקופית ' + (k + 1));
          (function (k) { b.addEventListener('click', function () { go(k); restart(); }); })(k);
          dotsWrap.appendChild(b);
        }
        mark();
      }
      function mark() {
        if (!dotsWrap) return;
        var c = current();
        Array.prototype.forEach.call(dotsWrap.children, function (d, k) { d.classList.toggle('is-active', k === c); });
      }
      var t;
      track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(mark, 60); }, { passive: true });
      var prev = sl.querySelector('.hx-slider__nav--prev'), next = sl.querySelector('.hx-slider__nav--next');
      if (prev) prev.addEventListener('click', function () { go(current() - 1); restart(); });
      if (next) next.addEventListener('click', function () { go(current() + 1); restart(); });
      var auto = (parseInt(sl.getAttribute('data-auto'), 10) || 0) * 1000, timer = null, visible = false, hover = false;
      function stop() { clearInterval(timer); timer = null; }
      function start() { stop(); if (auto && visible && !hover) timer = setInterval(function () { go(current() + 1); }, auto); }
      function restart() { start(); }
      sl.addEventListener('mouseenter', function () { hover = true; stop(); });
      sl.addEventListener('mouseleave', function () { hover = false; start(); });
      track.addEventListener('touchstart', function () { hover = true; stop(); }, { passive: true });
      track.addEventListener('touchend', function () { hover = false; setTimeout(start, 4000); }, { passive: true });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (e) { visible = e[0].isIntersecting; visible ? start() : stop(); }, { threshold: 0.3 }).observe(sl);
      }
      buildDots();
      window.addEventListener('resize', function () { buildDots(); });
    });
  }

  function initGallery(root) {
    root.querySelectorAll('[data-hx-gallery]').forEach(function (g) {
      if (g.__hx) return; g.__hx = 1;
      var track = g.querySelector('.hx-gal__track');
      var slides = g.querySelectorAll('.hx-gal__slide');
      var thumbs = g.querySelectorAll('.hx-gal__thumb');
      var dots = g.querySelectorAll('.hx-dot');
      function setActive(idx) {
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === idx); });
        dots.forEach(function (t, k) { t.classList.toggle('is-active', k === idx); });
      }
      function go(idx) {
        var rtl = getComputedStyle(track).direction === 'rtl';
        var x = idx * track.clientWidth;
        track.scrollTo({ left: rtl ? -x : x, behavior: 'smooth' });
        setActive(idx);
      }
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
      dots.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
      var timer;
      track.addEventListener('scroll', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          var idx = Math.round(Math.abs(track.scrollLeft) / (track.clientWidth || 1));
          setActive(Math.min(idx, slides.length - 1));
        }, 60);
      }, { passive: true });
    });
  }

  function initProduct(root) {
    root.querySelectorAll('[data-hx-product]').forEach(function (pdp) {
      if (pdp.__hx) return; pdp.__hx = 1;
      var dataEl = pdp.querySelector('script[data-hx-json]');
      if (!dataEl) return;
      var data = JSON.parse(dataEl.textContent);
      var vmap = {};
      data.variants.forEach(function (v) { vmap[v.id] = v; });
      var offers = pdp.querySelectorAll('.hx-offer');
      var btns = Array.prototype.slice.call(pdp.querySelectorAll('[data-hx-atc]'));
      var sticky = document.querySelector('[data-hx-sticky="' + data.section + '"]');
      if (sticky) btns = btns.concat(Array.prototype.slice.call(sticky.querySelectorAll('[data-hx-atc]')));
      var msg = pdp.querySelector('.hx-msg');
      var defaultVariant = data.selected || data.variants[0].id;

      function selectedOffer() {
        for (var i = 0; i < offers.length; i++) if (offers[i].querySelector('input').checked) return offers[i];
        return null;
      }
      function unitVariants(offer) {
        var qty = offer ? parseInt(offer.getAttribute('data-qty'), 10) || 1 : 1;
        var sels = offer ? offer.querySelectorAll('select[data-unit]') : [];
        var ids = [];
        for (var i = 0; i < qty; i++) ids.push(sels[i] ? parseInt(sels[i].value, 10) : defaultVariant);
        return ids;
      }
      function calc(offer) {
        var ids = unitVariants(offer);
        var disc = offer ? parseFloat(offer.getAttribute('data-discount')) || 0 : 0;
        var base = 0, compare = 0;
        ids.forEach(function (id) {
          var v = vmap[id] || data.variants[0];
          base += v.price;
          compare += Math.max(v.compare || 0, v.price);
        });
        var now = Math.round(base * (1 - disc / 100));
        var was = Math.max(compare, base);
        return { now: now, was: was, save: was - now, qty: ids.length, ids: ids };
      }
      function fbtTotal() {
        var t = 0;
        pdp.querySelectorAll('[data-hx-fbt] input:checked').forEach(function (i) { t += parseInt(i.getAttribute('data-price'), 10) || 0; });
        return t;
      }
      function render() {
        offers.forEach(function (o) {
          o.classList.toggle('is-selected', o.querySelector('input').checked);
          var c = calc(o);
          var nowEl = o.querySelector('[data-o-now]'), wasEl = o.querySelector('[data-o-was]'), perEl = o.querySelector('[data-o-per]'), pill = o.querySelector('[data-o-save]');
          if (nowEl) nowEl.textContent = fmtMoney(c.now, data.money);
          if (wasEl) wasEl.textContent = c.save > 0 ? fmtMoney(c.was, data.money) : '';
          if (perEl) perEl.textContent = c.qty > 1 ? fmtMoney(Math.round(c.now / c.qty), data.money) + ' ליחידה' : '';
          if (pill) { pill.textContent = c.save > 0 ? 'חוסכים ' + fmtMoney(c.save, data.money) : ''; pill.hidden = c.save <= 0; }
        });
        var o = selectedOffer();
        var c = calc(o);
        var total = c.now + fbtTotal();
        pdp.querySelectorAll('[data-hx-now]').forEach(function (e) { e.textContent = fmtMoney(c.now, data.money); });
        pdp.querySelectorAll('[data-hx-was]').forEach(function (e) { e.textContent = c.save > 0 ? fmtMoney(c.was, data.money) : ''; e.hidden = c.save <= 0; });
        pdp.querySelectorAll('[data-hx-save]').forEach(function (e) {
          var pct = c.was ? Math.round((c.save / c.was) * 100) : 0;
          e.textContent = (e.getAttribute('data-style') === 'percent' ? pct + '% הנחה' : 'חוסכים ' + fmtMoney(c.save, data.money));
          e.hidden = c.save <= 0;
        });
        var unlock = pdp.querySelector('[data-hx-unlock]');
        if (unlock && o) {
          var nxt = null;
          for (var i = 0; i < offers.length; i++) if (offers[i] === o) nxt = offers[i + 1] || null;
          var tip = nxt ? nxt.getAttribute('data-unlock') : '';
          unlock.textContent = tip || unlock.getAttribute('data-done') || '';
          unlock.hidden = !unlock.textContent;
        }
        var avail = c.ids.every(function (id) { return vmap[id] && vmap[id].available; });
        btns.forEach(function (b) {
          var lbl = b.querySelector('.hx-btn__label');
          var tpl = avail ? (b.getAttribute('data-label') || '') : (b.getAttribute('data-soldout') || 'אזל מהמלאי');
          if (lbl) lbl.textContent = tpl.replace('[price]', fmtMoney(total, data.money));
          b.disabled = !avail;
        });
        if (sticky) {
          var sp = sticky.querySelector('[data-hx-sticky-price]');
          if (sp) sp.textContent = fmtMoney(total, data.money) + (c.qty > 1 ? ' · ' + c.qty + ' יח׳' : '');
        }
      }
      offers.forEach(function (o) {
        o.querySelector('input').addEventListener('change', render);
        o.querySelectorAll('select').forEach(function (s) { s.addEventListener('change', render); s.addEventListener('click', function (e) { e.stopPropagation(); }); });
      });
      pdp.querySelectorAll('[data-hx-fbt] input').forEach(function (i) { i.addEventListener('change', render); });

      function addToCart() {
        var o = selectedOffer();
        var c = calc(o);
        var bundleName = o ? o.getAttribute('data-name') : '';
        var counts = {};
        c.ids.forEach(function (id) { counts[id] = (counts[id] || 0) + 1; });
        var items = Object.keys(counts).map(function (id) {
          var it = { id: parseInt(id, 10), quantity: counts[id] };
          if (bundleName && c.qty > 1) it.properties = { '_חבילה': bundleName };
          return it;
        });
        pdp.querySelectorAll('[data-hx-fbt] input:checked').forEach(function (i) { items.push({ id: parseInt(i.value, 10), quantity: 1 }); });
        btns.forEach(function (b) { b.classList.add('is-loading'); b.disabled = true; });
        if (msg) msg.textContent = '';
        var done = function () { btns.forEach(function (b) { b.classList.remove('is-loading'); }); render(); };
        var fail = function (m) { if (msg) msg.textContent = m || 'משהו השתבש, נסו שוב'; done(); };
        var A = window.Shopify && window.Shopify.actions;
        function hxOpenDrawer(noRefresh) {
          var d = document.getElementById('cart-drawer');
          if (!d) { window.location.href = '/cart'; return; }
          if (noRefresh) { if (d.open && !d.isOpen) d.open(); return; }
          fetch('/?sections=cart-drawer-section').then(function (r) { return r.json(); }).then(function (j) {
            var h = j['cart-drawer-section'];
            if (h) { var t = document.createElement('div'); t.innerHTML = h; var n = t.querySelector('.cart-drawer__inner'), o = d.querySelector('.cart-drawer__inner'); if (n && o) o.replaceWith(n); }
            if (d.open && !d.isOpen) d.open();
          }).catch(function () { window.location.href = '/cart'; });
        }
        function legacy() {
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
            .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
            .then(function (r) {
              if (!r.ok) return fail(r.j.description || r.j.message);
              if (data.after === 'checkout') { window.location.href = '/checkout'; return; } done(); hxOpenDrawer();
            }).catch(function () { fail(); });
        }
        if (A && A.updateCart) {
          var lines = items.map(function (it) {
            var l = { merchandiseId: 'gid://shopify/ProductVariant/' + it.id, quantity: it.quantity };
            if (it.properties) l.attributes = Object.keys(it.properties).map(function (k) { return { key: k, value: it.properties[k] }; });
            return l;
          });
          A.updateCart({ lines: lines }, { event: { context: 'product' } }).then(function (res) {
            if (res && res.userErrors && res.userErrors.length) return fail(res.userErrors[0].message);
            done();
            if (data.after === 'checkout') { window.location.href = '/checkout'; return; }
            if (A.openCart) A.openCart(); else hxOpenDrawer(true);
          }).catch(function () { legacy(); });
        } else legacy();
      }
      btns.forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          if (b.hasAttribute('data-hx-scroll')) {
            var tgt = pdp.querySelector('.hx-bundles') || pdp;
            var r = tgt.getBoundingClientRect();
            if (r.bottom < 0 || r.top > window.innerHeight) { tgt.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
          }
          addToCart();
        });
      });

      if (sticky) {
        var mainBtn = pdp.querySelector('.hx-buy [data-hx-atc]');
        if (mainBtn && 'IntersectionObserver' in window) {
          new IntersectionObserver(function (ent) {
            var e = ent[0];
            sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
          }).observe(mainBtn);
        }
      }
      render();
    });
  }

  function initUgc(root) {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { var v = e.target; if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); });
    }, { threshold: 0.4 });
    root.querySelectorAll('.hx-ugc__item video').forEach(function (v) { if (!v.__hx) { v.__hx = 1; io.observe(v); } });
  }

  function init(root) {
    root = root || document;
    initAnn(root); initGallery(root); initSliders(root); initProduct(root); initDelivery(root); initUgc(root); tickCountdowns();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
